import React from "react";

const DashboardHome = () => {
  return (
    <div style={{ backgroundColor: "#FAFBFE" }} className="w-full h-full p-8">
      <div className="flex">
        <p className="text-xl ml-2">Dashboard</p>
      </div>
    </div>
  );
};

export default DashboardHome;
